import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-company-application',
  templateUrl: './company-application.component.html',
  styleUrls: ['./company-application.component.scss']
})
export class CompanyApplicationComponent implements OnInit {
  tab = 0;

  constructor(
    private companyService: CompanyService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {

  }
}
